import React from 'react';
import ViewFeedback from './viewFeedback/ViewFeedback';

export default function FeedbackAdminPortal() {
  return (
    <div>
      <ViewFeedback />
    </div>
  );
}
